import { normalizeWeightClassForLevel } from "./competitionFederationConfig";

const getClientCompetitions = (client) =>
  Array.isArray(client?.competitions) ? client.competitions : [];

export const isCompetitionSelectionCandidate = ({
  client,
  gender,
  searchTerm = "",
  selectedClients = [],
}) => {
  const normalizedSearch = searchTerm.toLowerCase();
  const fullName =
    `${client?.nameForCoach ?? ""} ${client?.surnameForCoach ?? ""}`.toLowerCase();
  const isSearchTermMatch = searchTerm ? fullName.includes(normalizedSearch) : true;
  const isNotSelected = !selectedClients.includes(client);

  return (
    isSearchTermMatch &&
    isNotSelected &&
    client?.gender === gender &&
    client?.status === "active-string"
  );
};

export const isClientInCompetition = ({ client, competitionId }) =>
  client?.status === "active-string" &&
  getClientCompetitions(client).some((comp) => comp.id === competitionId);

export const isClientInCompetitionWeightClass = ({
  client,
  competition,
  weightClass,
  gender = undefined,
}) =>
  (gender === undefined || client?.gender === gender) &&
  client?.status === "active-string" &&
  getClientCompetitions(client).some(
    (comp) =>
      comp.id === competition.id &&
      normalizeWeightClassForLevel(
        comp.weightClass,
        competition.competitionLevel,
        client.gender
      ) === weightClass
  );

export const isSelectedClientInCompetitionWeightClass = ({
  client,
  competitionLevel,
  weightClass,
  gender = undefined,
}) =>
  (gender === undefined || client?.gender === gender) &&
  client?.status === "active-string" &&
  normalizeWeightClassForLevel(
    client.selectedWeightClass,
    competitionLevel,
    client.gender
  ) === weightClass;

export const isClientInCompetitionGender = ({
  client,
  gender,
  competitionId,
}) =>
  client?.gender === gender &&
  client?.status === "active-string" &&
  getClientCompetitions(client).some((comp) => comp.id === competitionId);
